/**********************************************************
Alexander Self
8/22/17
Gang builder container: manages the routes and components
**********************************************************/
import { browserHistory } from 'react-router';
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CULTIVATION_URLS } from './cult_constants';
import Tabs from './components/tabs';
const $ = window.$;

class Cultivation extends Component {
  componentDidMount() {
    $(document).ready(function(){
      $('.mobile-nav-collapsible').collapsible();
    });
  }
  render() {
    return (
      <div>
        <div className="row cult-tabs-display-lg">
          <h5 className={'pointer'} onClick={() => browserHistory.push('/cultivation')}>Cultivation <span className="flow-text right">{ moment().format("dddd, MMMM Do YYYY") }</span></h5><hr />
          <Tabs id={"cultivation"} tabs={CULTIVATION_URLS} level={this.props.user.level} />
        </div>
        <div className="row cult-tabs-display-sm">
        <ul className="collapsible mobile-nav-collapsible" data-collapsible="accordion">
          <li>
            <div className="collapsible-header"><i className="material-icons">apps</i><b>Menu</b></div>
            <div className="collapsible-body">
              <ul className="collection">
                {
                  CULTIVATION_URLS.concat({ name: 'Introduction', url: '/cultivation', level: 1 }).map((c) => (
                    <li key={c.name} className="collection-item chem-list-item"
                      onClick={() => { browserHistory.push(c.url); $('.mobile-nav-collapsible').collapsible('close', 0); }}>
                      {c.name}
                    </li>
                  ))
                }
                <br />
              </ul>
            </div>
          </li>
        </ul>

        </div>
        <div className="cultivation-display">
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Cultivation);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/index.js